import { AnimationsCache } from '@gem/modules/cache';

import Entities from 'STORE';

export const animationsCache = new AnimationsCache({
  appVersion: Entities.App.version,
});
